import { addMetadata, useApp, useCollection } from '@hb/react'
import { insurersCollection, LogEntry } from '@hb/shared'
import { updateDoc } from 'firebase/firestore'
import React, { useCallback, useMemo } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { Loading } from '../../../Loading'
import { LogView } from './LogView'
import { injectPatientLogItems } from './utils'

export const GynLog: React.FC<{
  maxHeight: number
}> = ({ maxHeight }) => {
  const data = useProfile()
  const { user, patientRef, userId } = data
  const { appName } = useApp()

  const { items: insurers } = useCollection(insurersCollection)
  const injectedLog = useMemo(
    () => injectPatientLogItems(user?.gyn?.log, user, insurers),
    [user, insurers],
  )

  const handleUpdateLog = useCallback(
    async (id: string, newEntry: LogEntry) =>
      patientRef
        ? updateDoc(patientRef, `gyn.log.${id}`, addMetadata(newEntry, appName, false))
            .then(() => ({ success: 'Updated!' }))
            .catch((err: any) => {
              console.error(err)
              return { error: err.message }
            })
        : { error: 'No patientRef' },
    [patientRef, appName],
  )

  if (!userId) {
    return <Loading text="Loading patient data..." />
  }

  return <LogView maxHeight={maxHeight} type="gyn" log={injectedLog} updateLog={handleUpdateLog} />
}
